import { FrameName } from "../config";
import CattleRangeBuildingTileEntity from "./CattleRangeBuildingTileEntity";

class CattleRangeSpecialBuildingTileEntity extends CattleRangeBuildingTileEntity {
	public static readonly frameName = FrameName.CATTLE_RANGE_SPECIAL;
}

export default CattleRangeSpecialBuildingTileEntity;
